import { Text, View } from "@react-pdf/renderer";
import amlReportStyles from "../Styles/amlReportStyles";
import dayjs from "dayjs";
import { isVeriffSession } from "../../CheckDetails/Utils/isVeriffSession";

const MetaData = ({ state }) => {
  return (
    <View
      style={{
        ...amlReportStyles.section,
        // ...amlReportStyles.footer,
        // bottom: 45,
      }}
      wrap
      // break
      // only render here if there is at least ~300pt free;
      // otherwise the whole block is moved to a new page
      // minPresenceAhead={300}
    >
      <View style={amlReportStyles.verticalSizeBox} />
      <View
        style={{
          ...amlReportStyles.footerContainer,
          // ...amlReportStyles.footer,
          // bottom: 45,
        }}
      >
        <View
          style={{
            ...amlReportStyles.checkDetailsColumn,
            width: "100%",
          }}
        >
          <View
            style={{
              ...amlReportStyles.checkDetailsRow,
              gap: 5,
              justifyContent: "space-around",
            }}
          >
            <View
              style={{
                ...amlReportStyles.checkDetailsColumn,
                flex: 1,
                alignItems: "flex-start",
              }}
            >
              <Text style={amlReportStyles.amlTextFooter}>REQUESTED BY</Text>
              <Text style={amlReportStyles.amlTextCaption}>
                {state?.createdBy || ""}
              </Text>
            </View>

            <View
              style={{
                ...amlReportStyles.checkDetailsColumn,
                flex: 1,
                alignItems: "flex-start",
              }}
            >
              <Text style={amlReportStyles.amlTextFooter}>CREATED ON</Text>
              <Text style={amlReportStyles.amlTextCaption}>
                {state?.createdAt
                  ? dayjs(state.createdAt).format("DD MMM YYYY")
                  : ""}
              </Text>
            </View>

            <View
              style={{
                ...amlReportStyles.checkDetailsColumn,
                flex: 1,
                alignItems: "flex-start",
              }}
            >
              <Text style={amlReportStyles.amlTextFooter}>DOWNLOADED ON</Text>
              <Text style={amlReportStyles.amlTextCaption}>
                {dayjs().format("DD MMM YYYY")}
              </Text>
            </View>
          </View>

          <View style={amlReportStyles.verticalSizeBox} />

          <View
            style={{
              ...amlReportStyles.checkDetailsRow,
              gap: 5,
              justifyContent: "space-around",
            }}
          >
            <View
              style={{
                ...amlReportStyles.checkDetailsColumn,
                flex: 1,
                alignItems: "flex-start",
              }}
            >
              <Text style={amlReportStyles.amlTextFooter}>DATA RETENTION</Text>
              <Text style={amlReportStyles.amlTextCaption}>
                {state?.expiration
                  ? dayjs(state.expiration).format("DD MMM YYYY")
                  : ""}
              </Text>
            </View>

            <View
              style={{
                ...amlReportStyles.checkDetailsColumn,
                flex: 1,
                alignItems: "flex-start",
              }}
            >
              <Text style={amlReportStyles.amlTextFooter}>VENDOR DATA</Text>
              <Text style={amlReportStyles.amlTextCaption}>
                {state?.vendorData || ""}
              </Text>
            </View>

            {isVeriffSession(state.checkType) ? (
              <View
                style={{
                  ...amlReportStyles.checkDetailsColumn,
                  flex: 1,
                  alignItems: "flex-start",
                }}
              >
                <Text style={amlReportStyles.amlTextFooter}>SESSION ID</Text>
                <Text style={amlReportStyles.amlTextCaption}>
                  {state?.sessionId || ""}
                </Text>
              </View>
            ) : (
              <View
                style={{
                  ...amlReportStyles.checkDetailsColumn,
                  flex: 1,
                  alignItems: "flex-start",
                }}
              ></View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default MetaData;
